module.exports = __webpack_public_path__ + "img/kv_5_2.16e701f8.png";